import React from 'react';
import { ExecutionLineItemTrpcResponse } from 'shared/src/trpc-types/line-item-trpc-types';
import { MediaTeamLineItemForm } from '@/features/line-items/line-item-form/media-trader-form/media-team-line-item-form';
import { MediaTraderLineItemUpdate } from 'shared/src/api/line-item-types';
import { trpc } from '@/utils/trpc-client';

type Props = {
  onClose: () => void;
  lineItem: ExecutionLineItemTrpcResponse;
};

export function MediaTeamLineItemFormContainer({ onClose, lineItem }: Props) {
  const { mutateAsync, isPending } = trpc.updateExecutionLineItem.useMutation();
  const utils = trpc.useUtils();

  async function onSubmit(data: MediaTraderLineItemUpdate) {
    if (isPending) return;
    await mutateAsync({
      strategy_id: lineItem.strategy_id,
      line_item_id: lineItem.id,
      lineItem: data
    });
    await utils.invalidate();
    onClose();
  }

  return <MediaTeamLineItemForm lineItem={lineItem} onSubmit={onSubmit} onClose={onClose} />;
}
